export const addTrailingSlashes = (link: string = '') => {
  let urlEndpoint = link;

  if (urlEndpoint?.substr(-1) !== '/') {
    urlEndpoint += '/';
  }

  return urlEndpoint;
};
